// extracted by mini-css-extract-plugin
export default {"Container":"Chip_Container__Q2vwY","appear":"Chip_appear__KAfJA"};